<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kuarNK/tc-custom/9781642504248.jpg?1700270522723" alt="This image is the cover for the book Chakra Tonics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chakra Tonics
      </h1>
      <p class="bookDescription body article font2">
        <b>Receive Energy Healing and Mental Balance</b><p><b>#1 New Release in Homeopathy Medicine</b><br/></p><p><b>The art of chakra balancing has never been tastier! Spiritual counselor and yoga instructor Elise Collins has created the perfect guide and recipe book of smoothies, teas, and tonics set to boost energy healing and restoration.</b></p><p><b>Balance your Chakras with food. </b>Our ancestors believed ingredients from the natural world cured not only physical ailments, but spiritual ones as well. Drawing on ancient wisdom, these restorative recipes contain powerful superfoods, herbs, minerals, and ph-balanced liquids designed to nourish the physical body and promote energy healing. </p><p><b>Target your chakras with tonics. </b>As you make your way through the chakra chart, find recipes that specifically target each chakra and clear out stale energy. And with bonus yoga techniques, learn how to release energy for Vedic vitality and a balanced mind. </p><p><b>Inside you’ll find, recipes like:</b></p>Sunrise juice for the sacral chakraPrana rising smoothie for the root chakraCarmelite water for the heart chakra<p></p><p><b>If you enjoyed books like <i>The Ultimate Guide to Chakras; Chakra Healing</i>; or <i>Chakras, Food, and You,</i> then you’ll love <i>Chakra Tonics</i>.</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elise Marie Collins
      </h2>
      
      <p class="authorDescription body article"><P><B>Elsie Marie Collins </B>is a yoga teacher, writer, and spiritual counselor. A graduate of Berkeley Psychic Institute, she has written for Yoga Journal and other alternative health magazines, and is the monthly Mind Body Spirit features writer for Psychic Reader. She lives in San Francisco.<br></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mango Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?76d1eabb